import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { UserLeaderboardStats } from '../dto/leaderboard.dto';

@Injectable({
  providedIn: 'root',
})
export class MockLeaderboardService {
  getUserStats(): Observable<UserLeaderboardStats> {
    // Mock data - in a real app, this would come from the backend
    const mockStats: UserLeaderboardStats = {
      interactionsRank: 5,
      interactionsCount: 42,
      interactionsTotal: 150,
      followsRank: 12,
      followsCount: 8,
      followsTotal: 200,
      favoriteCategory: 'IT',
      // Year stats
      interactionsRankYear: 23,
      interactionsCountYear: 512,
      interactionsTotalYear: 2500,
      followsRankYear: 45,
      followsCountYear: 89,
      followsTotalYear: 5000,
    };

    return of(mockStats).pipe(delay(300));
  }
}

